import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const POLL_MS = 60_000;
export const QUEUE_CHANGED = "sc-refund-queue-changed";

/** Open Sponsored Cashback refund requests for the admin nav badge + dashboard card. Silent on errors. */
export function useRefundQueue(enabled = true) {
  const [summary, setSummary] = useState(null);
  const { pathname } = useLocation();
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    const load = () => api.get("/admin/sponsored-cashback/refund-requests/summary")
      .then((r) => live && setSummary(r.data)).catch(() => live && setSummary(null));
    load();
    const t = setInterval(load, POLL_MS);
    window.addEventListener(QUEUE_CHANGED, load);
    return () => { live = false; clearInterval(t); window.removeEventListener(QUEUE_CHANGED, load); };
  }, [pathname, enabled]);
  return summary;
}
